import { useQuery } from "@tanstack/react-query";
import { supabase } from "./supabase";

export const FOTO_BUCKET = "app_fotos";
export const FOTO_GROESSE = 512;

/** Signierte Adresse für ein Profilfoto (privater Bucket, nur aktive Personen). Gilt eine Stunde. */
export function useFotoUrl(pfad: string | null | undefined): string | null {
  const q = useQuery({
    queryKey: ["foto", pfad],
    enabled: !!pfad && !!supabase,
    staleTime: 50 * 60 * 1000,
    queryFn: async () => {
      if (!supabase || !pfad) return null;
      const { data, error } = await supabase.storage.from(FOTO_BUCKET).createSignedUrl(pfad, 3600);
      if (error) throw error;
      return data.signedUrl;
    },
  });
  return q.data ?? null;
}

/** Quadratischer Ausschnitt aus der Mitte, 512 px, als JPEG. Läuft im Browser, nichts verlässt das Gerät vor dem Hochladen. */
export async function zuschneiden(datei: Blob, groesse = FOTO_GROESSE): Promise<Blob> {
  const bild = await createImageBitmap(datei);
  const seite = Math.min(bild.width, bild.height);
  const sx = (bild.width - seite) / 2;
  const sy = (bild.height - seite) / 2;
  const canvas = document.createElement("canvas");
  canvas.width = groesse;
  canvas.height = groesse;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("Bild konnte nicht bearbeitet werden.");
  ctx.drawImage(bild, sx, sy, seite, seite, 0, 0, groesse, groesse);
  bild.close();
  return new Promise((ok, fehler) =>
    canvas.toBlob((b) => (b ? ok(b) : fehler(new Error("Bild konnte nicht gespeichert werden."))), "image/jpeg", 0.86),
  );
}
